import i18n from '../imports/i18n'

export function rhpToYears(value) {
  let years = Math.floor(value)
  let months = Math.round((value % 1) * 12)
  //5.999 => 5y 12m;
  if (months === 12) {
    years++
    months = 0
  }
  if (years > 0) {
    return years + 'y' + (months > 0 ? ' ' + months + 'm' : '')
  } else {
    return months + 'm'
  }
}

export function valueToLabel(from, to) {
  return from === to ? from : from + ' - ' + to
}

export function round(value, decimal) {
  const pow = Math.pow(10, decimal)
  return Math.round(value * pow) / pow
}

export function humanReadableFormat(value, decimalFormatter) {
  let formattedValue
  if (value < 1) {
    formattedValue = decimalFormatter(value)
  } else {
    const moltiplier = ['', 'k', 'M', 'G', 'T', 'P', 'X', 'E', 'Z']
    const log = Math.log10(value)
    const power = Math.min(Math.floor(log / 3), moltiplier.length - 1)
    formattedValue = decimalFormatter(value / Math.pow(10, power * 3)) + moltiplier[power]
  }

  if (formattedValue.includes('%')) {
    formattedValue = formattedValue.replace('%', '') + '%'
  }
  return formattedValue
}

export function dateISOString(param) {
  var date = param != undefined || param != null ? new Date(param) : new Date()
  var tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function (num) {
      var norm = Math.floor(Math.abs(num))
      return (norm < 10 ? '0' : '') + norm
    }
  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    'T' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds()) +
    dif +
    pad(tzo / 60) +
    ':' +
    pad(tzo % 60)
  )
}

export function convertStringLengthToPixel(arrOptions) {
  const font = '12.8px Segoe UI' /* current app font Segoe UI - fontSize: 0.8rem */

  let longest_string = arrOptions.reduce((a, b) => {
    return a.length > b.length ? a : b
  }, '')

  let canvas = document.createElement('canvas')
  let context = canvas.getContext('2d')

  context.font = font

  let width = context.measureText(longest_string).width
  let rounded_width = Math.ceil(width) /* rounds a number up to the next largest integer */

  return rounded_width
}

export function setChartMenuItemsLang() {
  return {
    printChart: i18n.t('common.highcharts.printChart'),
    viewFullscreen: i18n.t('common.highcharts.viewFullscreen'),
    downloadPNG: i18n.t('common.highcharts.downloadPNG'),
    downloadJPEG: i18n.t('common.highcharts.downloadJPEG'),
    downloadPDF: i18n.t('common.highcharts.downloadPDF'),
    downloadSVG: i18n.t('common.highcharts.downloadSVG'),
  }
}

export function mathRoundPercentage(value) {
  return Math.round(value * 100) + '%'
}

export function preventCharsCode(evt) {
  const charCode = evt.which ? evt.which : evt.keyCode
  return charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 ? evt.preventDefault() : true
}

export function formatDate(value) {
  const temp = value.split('T')
  const date = new Date(temp[0])
  const time = temp[1]

  return date && time ? i18n.d(date, 'short') + ', ' + time : null
}

export function dateYearMonthDay(value) {
  const temp = value.split('T')
  const date = new Date(temp[0])
  const time = temp[1]

  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1

  return date && time ? date.getFullYear() + '.' + month + '.' + day + ' ' + time : null
}

export function formatShortDate(value) {
  return value ? i18n.d(new Date(value), 'short') : value
}

export function formatCurrency(value, currency) {
  return value != undefined && value != null && !isNaN(value)
    ? i18n.n(value, { key: 'currency', currency: currency })
    : null
}

export function formatPercentage(value) {
  return value != undefined && value != null && !isNaN(value) ? i18n.n(value, 'percent') : null
}

export const isNearlyEqual = (a, b, epsilon = 0.0001) => {
  return Math.abs(a - b) < epsilon
}

export function capitalize(s) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
